import axios from '../axiosInstance.js';

export const getAllCategories = () => axios.get('/categories');

export const getCategory = (slug) => axios.get(`/categories/${slug}`);

export const getServiceItem = (slug) => axios.get(`/service/${slug}`);
